import React from "react";

export const PicInPicIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M21 9.41345V6.41345C21 5.88302 20.7893 5.37431 20.4142 4.99924C20.0391 4.62417 19.5304 4.41345 19 4.41345H4C3.46957 4.41345 2.96086 4.62417 2.58579 4.99924C2.21071 5.37431 2 5.88302 2 6.41345V16.4135C2 17.5135 2.9 18.4135 4 18.4135H8"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 13.4135H14C12.8954 13.4135 12 14.3089 12 15.4135V18.4135C12 19.518 12.8954 20.4135 14 20.4135H20C21.1046 20.4135 22 19.518 22 18.4135V15.4135C22 14.3089 21.1046 13.4135 20 13.4135Z"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
